var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4675 0H6.53248C2.92469 0 0 2.79008 0 6.23182V39.5584C0 43.0001 2.92469 45.7902 6.53248 45.7902H41.4675C45.0753 45.7902 48 43.0001 48 39.5584V6.23182C48 2.79008 45.0753 0 41.4675 0Z",
    fill: "#111834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0975 10.2206C12.1704 10.125 10.5877 11.6745 10.6854 13.5613C10.7688 15.1764 12.1094 16.489 13.7597 16.5712C15.6868 16.6669 17.2695 15.1172 17.1718 13.2306C17.0878 11.6155 15.7471 10.3022 14.0975 10.2206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.861 18.7062H10.9966V36.1774H16.861V18.7062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7956 18.2946C28.5393 18.2946 26.9539 19.3485 25.8455 20.6944V18.7063H19.981V36.1774H25.8455V25.9398C26.0042 23.7403 27.6079 23.1662 28.7459 23.1662C29.9442 23.1662 31.4575 23.7371 31.4575 26.9474V36.1767H37.3219V23.8706C37.3219 23.8706 37.0589 18.2946 30.7956 18.2946Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7737db4ef9e7590ba9b4ffba6576394a.svg";
export { ForwardRef as ReactComponent };